import { render } from "./UsersList.vue?vue&type=template&id=66c0d8ce"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Rich Nas/Work/East Side Mafia/VUE/simple-app-2/simple-app-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__